import { create } from 'zustand';
import { msalConfig } from '../../configs/msalConfig';
import { captureException } from '@sentry/browser';
import { getOfficeAccessToken } from './service';

interface Store {
  preciselyToken: string;
  setPreciselyToken: (token: string) => void;
  officeToken: string;
  setOfficeToken: (token: string) => void;
  officeTokenState: 'uninitialized' | 'loading' | 'success' | 'error';
  initiateOfficeToken: () => void;
}

export const useAuthenticationStore = create<Store>(set => ({
  preciselyToken: '',
  setPreciselyToken: (token: string) => set({ preciselyToken: token }),
  officeToken: '',
  officeTokenState: 'uninitialized',
  setOfficeToken: (token: string) => set({ officeToken: token }),

  initiateOfficeToken: async () => {
    set({ officeTokenState: 'loading' });
    try {
      const accessToken = await getOfficeAccessToken();
      set({ officeToken: accessToken });
      set({ officeTokenState: 'success' });
    } catch (error) {
      captureException(error);
      set({ officeTokenState: 'error' });
    }
  },
}));
